import React from 'react';
import styles from './FreeShippingBadge.module.scss';
import FreeShippingIcon from './FreeShippingIcon.svg';

export default function FreeShippingBadge({
  className = '',
}: {
  className?: string;
}) {
  return (
    <div className={`${styles.FreeShippingBadge} ${className}`}>
      <FreeShippingIcon /> Free Shipping
    </div>
  );
}
